export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'
export const DEFAULT_TIME_FORMAT = 'hh:mm:ss A'
export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY hh:mm:ss A'
